package com.flowyride.data.speedcameras.datagouv

/**
 * "Liste des radars fixes en France" (Ministère de l'Intérieur, Licence Ouverte), read through
 * the data.gouv.fr tabular API. The resource id changes with each yearly release: update it here.
 * https://www.data.gouv.fr/datasets/6712583387af110196942793
 */
data class DataGouvConfig(
    val baseUrl: String = "https://tabular-api.data.gouv.fr",
    val resourceId: String = "17f7cfd9-a5fe-4b6a-9f5d-3625feaa396e",
    /** Maximum accepted by the API. */
    val pageSize: Int = 200,
)
